import EventHandler from '@pixelunion/events';
import FacetedFiltering from '../components/FacetedFiltering';

export default class StaticCollection {
  constructor(section) {
    this.el = section.el;
    this.events = new EventHandler();
    this.sortSelect = this.el.querySelector('[data-collection-sort]');
    this.facetedFilters = null;

    if (this.el.querySelector('[data-faceted-filter]')) {
      this.facetedFilters = new FacetedFiltering(this.el);
    }

    if (this.sortSelect) {
      this.events.register(this.sortSelect, 'change', () => this._updateSort());
    }
  }

  _updateSort() {
    let search;
    const Sorting = {};
    Sorting.sort_by = this.sortSelect.value;

    const currentVendorSelected = this.sortSelect.classList.contains('vendor-collection');

    if (currentVendorSelected || this.facetedFilters !== null) {
      const currentSearch = window.location.search;

      const searchParts = currentSearch.split('&');

      for (let index = 0; index < searchParts.length; index++) {
        const part = searchParts[index];
        if (part.indexOf('sort_by') !== -1) {
          searchParts.splice(index, 1);
        }
      }

      search = searchParts.join('&');
      window.location.search = `${search}&${Object.keys(Sorting).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(Sorting[k])}`).join('&')}`;
    } else {
      window.location.search = Object.keys(Sorting).map(k => `${encodeURIComponent(k)}=${encodeURIComponent(Sorting[k])}`).join('&');
    }
  }


  onSectionUnload() {
    if (this.facetedFilters) {
      this.facetedFilters.unload();
    }
  }
}
